<mat-toolbar class="statsbg">

    <div>
        <button mat-icon-button (click)="backToList()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <div class="title">
            <mat-icon>{{GLOBAL.ICONS.STAT}}</mat-icon>
            <ng-container>
                STATS
            </ng-container>
        </div>
    </div>
    <div>
        {{months[month]}} {{year}} {{year ? '-' : ''}} {{uniqueStat}} {{uniqueStat ?
        (sortOptionsForm.controls['uniqueStatPerc'].value ? ' % -' : ' - ') : ''}}
        {{sortOptionsForm.controls['statReport'].value | param:'statReports'}}
    </div>
    <div>
        <button *ngIf="viewMode !== 'pie'" mat-icon-button (click)="viewchart()">
            <mat-icon>{{GLOBAL.ICONS.CHARTPIE}}</mat-icon>
        </button>
        <button *ngIf="viewMode !== 'graph'" mat-icon-button (click)="viewgraph()">
            <mat-icon>{{GLOBAL.ICONS.CHARTBAR}}</mat-icon>
        </button>
        <button *ngIf="viewMode !== 'table'" mat-icon-button (click)="viewtable()">
            <mat-icon>{{GLOBAL.ICONS.TABLE}}</mat-icon>
        </button>
        <profile></profile>
    </div>

</mat-toolbar>
<div class="toolbartop"></div>

<div class="main-container-flex split s20">
    <div class="main">
        <ng-container *ngIf="viewMode === 'pie'">
            <ngx-charts-advanced-pie-chart [results]="statService.statChartPie">
            </ngx-charts-advanced-pie-chart>
        </ng-container>
        <ngx-charts-bar-vertical-stacked *ngIf="viewMode === 'graph'" [results]="statService.statChart"
            [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel" [animations]="animations" [customColors]="customColors"
            (select)="onSelectBar($event)">
        </ngx-charts-bar-vertical-stacked>


        <!-- <table mat-table [dataSource]="statService.statChart" class="mat-elevation-z8" *ngIf="viewMode === 'table'">



            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">{{element.name}} </td>
            </ng-container>

            <ng-container *ngFor="let col of statCols">
                <ng-container matColumnDef="data">
                    <th mat-header-cell *matHeaderCellDef>{{data.name}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.value}}
                    </td>
                </ng-container>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="statColsDate"; sticky: true">
            </tr>
            <tr mat-row *matRowDef="let row; let element; columns: statColsDate;">
            </tr>
        </table> -->


    </div>
    <div class="side">
        <form [formGroup]="sortLocalForm" novalidate>

            <mat-form-field appearance="fill" *ngIf="!isRealtor()">
                <mat-label>Agency</mat-label>
                <mat-select formControlName="agency">
                    <mat-option value="">
                        All Agencies
                    </mat-option>
                    <mat-option value="byAgency">
                        By Agency
                    </mat-option>
                    <mat-option *ngFor="let param of 'userAgencies' | params" [value]="param.id">
                        {{param.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill"
                *ngIf="sortLocalForm.value.agency && sortLocalForm.value.agency !== 'byAgency'">
                <mat-label>Realtor</mat-label>
                <mat-select formControlName="realtor">
                    <mat-option value="">
                        All Agents
                    </mat-option>
                    <mat-option value="byRealtor">
                        By Agent
                    </mat-option>
                    <ng-container *ngIf="!isRealtor()">
                        <mat-option *ngFor="let param of setting.realtorsAgency[sortLocalForm.controls['agency'].value]"
                            [value]="param.id">
                            {{param.name}}
                        </mat-option>
                    </ng-container>
                    <mat-option *ngIf="isRealtor()" [value]="auth.uid">
                        {{auth.profile.values.fullname}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>


        <form [formGroup]="sortOptionsForm" novalidate>
            <mat-form-field appearance="fill">
                <mat-label>Reports</mat-label>
                <mat-select formControlName="statReport">
                    <mat-option *ngFor="let param of 'statReports' | params" [value]="param.id">
                        {{param.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill"
                *ngIf="statService.statConfs[sortOptionsForm.controls['statReport'].value].mandateType">
                <mat-label>Type</mat-label>
                <mat-select formControlName="type">
                    <mat-option [value]="null">
                        No Selection
                    </mat-option>
                    <mat-option value="sale">
                        Sale
                    </mat-option>
                    <mat-option value="rental">
                        Rental
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" *ngIf="uniqueStat">
                <mat-slide-toggle formControlName="uniqueStatPerc">% Percentage
                </mat-slide-toggle>
                <textarea matInput hidden></textarea>
            </mat-form-field>
        </form>
    </div>
</div>
<!-- <table mat-table [dataSource]="statService.statList" class="main">

    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element"> {{element.date}} </td>
    </ng-container>

    <ng-container *ngFor="let col of statService.statCols[groupStat]" [matColumnDef]="col.id">
        <th mat-header-cell *matHeaderCellDef>{{col.name}}</th>
        <td mat-cell *matCellDef="let element">
            {{element[col.id]}}
        </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="tableCols; sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; let element; columns: tableCols;">
    </tr>
</table> -->